import context from '@truckdown/systems';
import { defineComponent, ref, Ref, onMounted, onUnmounted } from 'vue';
import { Constants } from '../../constants';

interface IData {
    isPlanRV: Ref<boolean>;
    isAdmin: Ref<boolean>;
    isAuthenticated: Ref<boolean>;
    hasRealUsername: Ref<boolean>;
    sysAdmin: Ref<boolean>;

    firstName: Ref<string | undefined>;
    lastName: Ref<string | undefined>;

    showFleetSetupWidget: Ref<boolean>;
    showMenu: Ref<boolean>;
    showContext: Ref<boolean>;
    showControlPanel: Ref<boolean>;
}

const isUserAnAdmin = function (): boolean {
    if (!context.isAuthenticated) {
        return false;
    }
    return context.isInRole(Constants.Roles.SystemRole)
        || context.isInRole(Constants.Roles.CSRRole);
}

const isSysAdmin = function (): boolean {
    if (!context.isAuthenticated) {
        return false;
    }
    return context.isInRole(Constants.Roles.SystemRole);
}

const fleetSetupWidgetCheck = function (): boolean {
    if (!context.isAuthenticated) {
        return false;
    }

    if (context.isInRole("General Admin")
        && !context.isInRole("Fleet User")
        && context.settings["accounttype"] != "Vendor"
        && context.settings["fleet_onboarding"] != "complete"
        && context.settings["fleet_onboarding"] != "dismissed") {
        return true;
    }

    return false;
}

const refreshContextData = function (data: IData) {
    data.isAuthenticated.value = context.isAuthenticated;
    data.isPlanRV.value = context.system == 'planrv';
    data.isAdmin.value = isUserAnAdmin();
    data.sysAdmin.value = isSysAdmin();
    data.firstName.value = context.user?.firstName;
    data.lastName.value = context.user?.lastName;

    data.hasRealUsername.value = context.hasClaim(Constants.Claims.RealUser);

    data.showFleetSetupWidget.value = fleetSetupWidgetCheck();
}

const getData = function () {
    let data = {
        isPlanRV: ref<boolean>(false),
        isAdmin: ref<boolean>(false),
        isAuthenticated: ref<boolean>(false),
        hasRealUsername: ref<boolean>(false),
        sysAdmin: ref<boolean>(false),

        firstName: ref<string | undefined>(),
        lastName: ref<string | undefined>(),

        showFleetSetupWidget: ref<boolean>(false),
        progressPercent: ref<number>(0),
        showMenu: ref<boolean>(false),
        showContext: ref<boolean>(false),
        showControlPanel: ref<boolean>(false)
    } as IData;

    refreshContextData(data);
    return data;
}

const getMethods = function (data: IData) {
    return {
        toggleMenu: function (evt: Event) {
            data.showMenu.value = !data.showMenu.value;
            if (data.showMenu.value) {
                data.showContext.value = false;
                data.showControlPanel.value = false;
            }
        },
        closeMenu: function (evt: Event) {
            data.showMenu.value = false;
        },
        toggleContext: function (evt: Event) {
            data.showContext.value = !data.showContext.value;
            if (data.showContext.value) {
                data.showMenu.value = false;
                data.showControlPanel.value = false;
            }
        },
        closeContext: function (evt: Event) {
            data.showContext.value = false;
        },
        toggleControlPanel: function (evt: Event) {
            data.showControlPanel.value = !data.showControlPanel.value;
            if (data.showControlPanel.value) {
                data.showMenu.value = false;
            }
        },
        closeControlPanel: function (evt: Event) {
            data.showControlPanel.value = false;
        }
    }
}

export default defineComponent({
    name: 'HeaderMenu',
    setup: function () {
        const data = getData();
        const methods = getMethods(data);

        const refreshContext = function () {
            refreshContextData(data);
        }

        onMounted(() => {
            if (context.isAuthenticated) {
                context.events.on(Constants.Events.RefreshOnboardingProgress, refreshContext);
            }
        });

        onUnmounted(() => {
            context.events.off(Constants.Events.RefreshOnboardingProgress, refreshContext);
        });

        return {
            ...data,
            ...methods
        };
    }
});


